import { keepPreviousData } from "@tanstack/react-query";
import { useGlobals } from "@/components/providers/globals-provider.tsx";
import useQueryApiClient from "@/hooks/use-query-api-client.ts";
import { useAppSelector } from "@/redux/store.ts";
import { type Nullable, WebComponentMode } from "@/types";
import getSubFamilyConfig from "../queries/get-sub-family-config.ts";
import type { ModelCode } from "../types";

export default function useSubFamiliesConfigFetch(modelCode: Nullable<ModelCode>) {
    const { site, locale, mode } = useGlobals();

    const subFamilySmartNumber = useAppSelector((state) => state.smartNumber.subFamily);

    const { data, isPlaceholderData, isLoading, isError, failureCount, refetch } = useQueryApiClient({
        queryKey: ["config", modelCode, subFamilySmartNumber],
        queryFn: () => getSubFamilyConfig(modelCode, subFamilySmartNumber, site, locale),
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        placeholderData: keepPreviousData,
        staleTime: mode === WebComponentMode.Website ? Infinity : 0,
    });

    return { data, isPlaceholderData, isLoading, isError, failureCount, refetch };
}
